import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type { RadarCreative } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarCreativeTypes';

export function isAdvertValid(creative: RadarCreative): boolean {
  if (!Object.values<string>(ADVERT_FORMAT_TYPES).includes(creative.idFormat)) {
    return false;
  }

  if (creative.idFormat === ADVERT_FORMAT_TYPES.ITINERARY_INLINE_PLUS) {
    return !!creative.fields.itineraryId;
  }

  return true;
}
